import { CalendarDaysIcon } from "@heroicons/react/20/solid";
import moment from "moment";
import React, { useState, useEffect } from "react";
import Datepicker from "react-tailwindcss-datepicker";

const RangePicker = ({ test, setRangePicker, width }) => {
  // Initializing dates
  const today = moment().startOf("day");
  const todayStartDate = moment.utc().startOf("day");
  const todayEndDate = moment.utc().endOf("day");

  // State to hold the displayed date range
  const [dateToShow, setDateToShow] = useState({
    startDate: today.toDate(),
    endDate: today.toDate(),
  });

  // Handle date range change
  const handleValueChange = (newValue) => {
    const startDate = newValue.startDate ? moment.utc(newValue.startDate).startOf("day") : todayStartDate;
    const endDate = newValue.endDate ? moment.utc(newValue.endDate).endOf("day") : startDate;
    const startDateShow = newValue.startDate ? moment(newValue.startDate).startOf("day") : today;
    const endDateShow = newValue.endDate ? moment(newValue.endDate).endOf("day") : startDateShow;

    // Converting to UNIX timestamp
    const startDateUTCUnix = startDate.unix();
    const endDateUTCUnix = endDate.unix();

    // Updating parent component's state
    setRangePicker({ startDate: startDateUTCUnix, endDate: endDateUTCUnix });

    // Updating local state to reflect the change
    setDateToShow({ startDate: startDateShow.toDate(), endDate: endDateShow.toDate() });
  };

  // Initial setup
  useEffect(() => {
    // console.log("Effect ran");
    setRangePicker({
      startDate: todayStartDate.unix(),
      endDate: todayEndDate.unix(),
    });
    // Depending on your needs, you might want to include props here that,
    // when changed, should re-run this effect.
  }, []);

  return (
    <div className={`relative ${width || "w-40"}`}>
      <Datepicker
        value={dateToShow}
        onChange={handleValueChange}
        showShortcuts
        showFooter
        readOnly
        popoverDirection="down"
        toggleClassName="hidden"
        inputClassName="w-full pr-8 border-gray-400 rounded-full focus:ring-0 text-sm placeholder:text-gray-400"
        placeholder="Select Dates"
        displayFormat="ddd, MMM DD, YYYY"
      />
      <span className="absolute right-3 top-2">
        <CalendarDaysIcon className="w-5 h-5 text-primary-color-300" />
      </span>
    </div>
  );
};

export default RangePicker;
